import { render, staticRenderFns } from "./TrainingDetail.vue?vue&type=template&id=2e8d526a&scoped=true&"
import script from "./TrainingDetail.vue?vue&type=script&lang=js&"
export * from "./TrainingDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDetail.vue?vue&type=style&index=0&id=2e8d526a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d526a",
  null
  
)

export default component.exports